import { APIRoute } from '@/modules/utils'
import { Conversation } from '@/dataV3/Conversation/Conversation'
import { IRI } from 'emt-library'

export const Route = (path: IRI): APIRoute => ({
  method: 'POST',
  path,
})

export type UrlParams = {
  conversationId: string
}

export type Body = never

export type Response = Conversation
